<div style="display: flex;justify-content: center;margin-top: 30px">
    <div class="container1" style="width: 90%">


        <!--       <div *ngIf="!loading" style="display: flex;justify-content: center;margin-top: 1rem">
        <mat-form-field appearance="outline" class="divInputSearch">
          <mat-label>Filtrar</mat-label>
          <input matInput (keyup)="applyFilter($event)" placeholder="Filtrar Búsqueda"/>
        </mat-form-field>
      </div> -->

        <div *ngIf="loading" class="spinner">
            <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
        </div>

        <div style="display: flex;justify-content: space-between;">
            <div *ngIf="!loading" style="width: 32%;">
                <h2>Agrupados de Equipos Personalizables</h2>

                <div *ngIf="!loading" class="mat-elevation-z8">
                    <table mat-table [dataSource]="dataSource" style="min-width: 0%;">

                        <ng-container matColumnDef="nombre">
                            <th mat-header-cell *matHeaderCellDef>Nombre</th>
                            <td mat-cell *matCellDef="let element">{{ element.nombre }}</td>
                        </ng-container>

                        <!--                         <ng-container matColumnDef="productos">
                            <th mat-header-cell *matHeaderCellDef>Productos</th>
                            <td mat-cell *matCellDef="let element">{{ element.nombre }}</td>
                        </ng-container> -->

                        <ng-container matColumnDef="modificar">
                            <th mat-header-cell *matHeaderCellDef> Editar </th>
                            <td mat-cell *matCellDef="let element">
                                <button mat-icon-button color="primary"
                                    (click)="viewAgrupado(element.id,element.nombre)">
                                    <mat-icon>edit</mat-icon>
                                </button>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="asignarProducto">
                            <th mat-header-cell *matHeaderCellDef> Asignar Productos </th>
                            <td mat-cell *matCellDef="let element">
                                <button mat-icon-button color="primary" (click)="openDialogAsignarProducto(element)">
                                    <mat-icon>playlist_add</mat-icon>
                                </button>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="eliminar">
                            <th mat-header-cell *matHeaderCellDef> Eliminar </th>
                            <td mat-cell *matCellDef="let element;let i=index">
                                <button mat-icon-button color="primary" (click)="deleteCategoria(element,i)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

                    </table>
                </div>
                <!--         <div [hidden]="loading" style="width: 25rem;">
                <mat-paginator [pageSizeOptions]="[5, 10, 20]"
                               showFirstLastButtons style="width: 25rem;">
                </mat-paginator>
              </div> -->
                <div *ngIf="!loading" class="row" style="margin-top: 2%">
                    <button mat-raised-button style="background-color: #e95a1a;color: white"
                        (click)="addAgrupado()">Agregar Nuevo Agrupado</button>
                </div>
            </div>

            <div *ngIf="!showNewAgrupado && agrupadoControl.value!==''" style="width: 1px; background-color: gray; height: auto;"></div>

            <div style="width: 63%;">
                <div *ngIf="!showNewAgrupado && agrupadoControl.value!==''" style="display: flex;">
                    <h3>{{agrupadoControl.value}}</h3>
                    <button mat-icon-button color="primary" (click)="toggleEditModeNombreAgrupado()">
                        <mat-icon>{{ 'edit' }}</mat-icon>
                    </button>
                </div>


                <div *ngIf="showNewAgrupado">
                    <mat-form-field appearance="outline">
                        <mat-label>Nombre de Agrupado</mat-label>
                        <input matInput placeholder="Nombre de Agrupado" [formControl]="agrupadoControl"
                            name="nombreAgrupado" required>
                    </mat-form-field>

                    <button mat-icon-button color="primary" (click)="addAgrupadoNombre()">
                        <mat-icon>{{ 'done' }}</mat-icon>
                    </button>

                </div>



                <div *ngIf="showTable" style="display: flex;flex-direction: column;row-gap: 1rem;">
                    <div style="display: flex;justify-content: space-between;">
                        <div *ngIf="showForm" style="display: flex;flex-direction: column;column-gap:0.5rem;width: 100%;">
                            <mat-form-field appearance="outline">
                                <mat-label>Equipo</mat-label>
                                <input type="text" placeholder="Elige un equipo" matInput required [formControl]="nombreControl"
                                    [matAutocomplete]="auto">
                                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelectionChangedEquipo($event)">
                                    <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                                        {{option}}
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
        
                            <mat-form-field *ngIf="nombreControl.value !== '' " appearance="outline">
                                <mat-label>Marca</mat-label>
                                <input type="text" placeholder="Elige una marca" matInput required [formControl]="marcaControl"
                                    [matAutocomplete]="autoMarca">
                                <mat-autocomplete #autoMarca="matAutocomplete"
                                    (optionSelected)="onSelectionChangedMarca($event)">
                                    <mat-option *ngFor="let option of filteredOptionsMarca | async" [value]="option">
                                        {{option}}
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
        
                            <mat-form-field *ngIf="marcaControl.value!=='' " appearance="outline">
                                <mat-label>Modelo</mat-label>
                                <input type="text" placeholder="Elige un modelo" matInput required [formControl]="modeloControl"
                                    [matAutocomplete]="autoModelo">
                                <mat-autocomplete #autoModelo="matAutocomplete">
                                    <mat-option *ngFor="let option of filteredOptionsModelo | async" [value]="option">
                                        {{option}}
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                        </div>

                    </div>
                    
                    <div *ngIf="showForm" style="display: flex;justify-content: center;column-gap: 1rem;align-items: center;">
                        <button style="height: 50%;" mat-raised-button style="background-color: #e95a1a;color: white"
                            (click)="addEquipo()">Agregar
                        </button>
                    
                        <button style="height: 50%;" mat-raised-button style="background-color: #000000CF;color: white"
                            (click)="setShowForm()">Cancelar
                        </button>
                    </div>

                    <div class="mat-elevation-z8 overflow" *ngIf="dataSourceAgrupado.data?.length>0">
                        <table mat-table [dataSource]="dataSourceAgrupado">

                            <!--                         <ng-container matColumnDef="nombre">
                                <th mat-header-cell *matHeaderCellDef>EQUIPO</th>
                                <td mat-cell *matCellDef="let element">{{ element.nombreEquipo + " - " + element.marcaEquipo +
                                    " - " + element.modeloEquipo }}</td>
                            </ng-container> -->
                            <ng-container matColumnDef="nombre">
                                <th mat-header-cell *matHeaderCellDef>EQUIPO</th>
                                <td mat-cell *matCellDef="let element">{{ element.nombreEquipo }}</td>
                            </ng-container>

                            <ng-container matColumnDef="marca">
                                <th mat-header-cell *matHeaderCellDef>MARCA</th>
                                <td mat-cell *matCellDef="let element">{{ element.marcaEquipo }}</td>
                            </ng-container>

                            <ng-container matColumnDef="modelo">
                                <th mat-header-cell *matHeaderCellDef>MODELO</th>
                                <td mat-cell *matCellDef="let element">{{ element.modeloEquipo }}</td>
                            </ng-container>

                            <ng-container matColumnDef="talla">
                                <th mat-header-cell *matHeaderCellDef>TALLA</th>
                                <td mat-cell *matCellDef="let element">{{ element.tallaEquipo }}</td>
                            </ng-container>


                            <ng-container *ngFor="let column of paxColumns; let i = index" matColumnDef="{{ column }}">
                                <th mat-header-cell *matHeaderCellDef>PAX {{ i + 1 }}</th>
                                <td mat-cell *matCellDef="let element">
                                    <ng-container *ngIf="!element.editMode; else editModeTemplate">
                                        {{ element.nroPersonasPax[i] || '-' }}
                                    </ng-container>
                                    <ng-template #editModeTemplate>
                                        <input matInput type="text"
                                            style="background-color: #FDF6EC;border: solid;border-color: #D55014;border-width: 1px;padding: 0.2rem;"
                                            [(ngModel)]="element.nroPersonasPax[i]" *ngIf="element.editMode">
                                    </ng-template>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="editar">
                                <th mat-header-cell *matHeaderCellDef> Editar </th>
                                <td mat-cell *matCellDef="let element">
                                    <button *ngIf="element.editMode" mat-icon-button color="primary"
                                        (click)="saveChanges(element)">
                                        <mat-icon>{{ 'done' }}</mat-icon>
                                    </button>
                                    <button *ngIf="!element.editMode" mat-icon-button color="primary"
                                        (click)="toggleEditMode(element)">
                                        <mat-icon>{{ 'edit' }}</mat-icon>
                                    </button>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="eliminar">
                                <th mat-header-cell *matHeaderCellDef> Eliminar </th>
                                <td mat-cell *matCellDef="let element;let i=index">
                                    <button mat-icon-button color="primary" (click)="deleteEquipo(element,i)">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="HeaderList.concat(paxColumns.concat(HeaderActions))">
                            </tr>
                            <tr mat-row
                                *matRowDef="let row; columns: HeaderList.concat(paxColumns.concat(HeaderActions))"></tr>

                        </table>
                    </div>
                </div>

                <div [hidden]="!showTable ||dataSourceAgrupado.data?.length===0">
                    <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
                    </mat-paginator>
                </div>

                <div *ngIf="showTable && !showForm" style="display: flex;align-items: center;">
                    <button style="height: 50%;" mat-raised-button style="background-color: #e95a1a;color: white"
                        (click)="setShowForm()">Agregar Equipo
                    </button>
                </div>
            </div>
        </div>






    </div>

</div>